  // Set Last Used Voucher Data -------------------------
  export const setLastUsedVoucherData = (data) => {
    localStorage.setItem('voucher_type_default_last', JSON.stringify({
      voucher_type_name: data?.voucher_type_name,
      id: data?.id,
      method_of_voucher_number: data?.method_of_voucher_number,
      select_type_of_voucher: data?.select_type_of_voucher,
    }));
  };